import { render, staticRenderFns } from "./DataTagSidebar.vue?vue&type=template&id=5cc28d60&scoped=true&"
import script from "./DataTagSidebar.vue?vue&type=script&lang=js&"
export * from "./DataTagSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataTagSidebar.vue?vue&type=style&index=0&id=5cc28d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc28d60",
  null
  
)

export default component.exports